// extracted by mini-css-extract-plugin
export default {"container":"container__GaxHb","frame":"frame__JcanN","message":"message__G2YFS","link":"link__Dj18Y"};